import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import qs from 'qs';
import { selectTimeouts } from 'state/timeouts';
import useIdleTimer from 'hooks/useIdleTimer';

import AppTimeoutModalView from './AppTimeoutModalView';

import useWarning from './useWarning';
import useQueryParameters, {
  useSecureQueryParameters,
} from 'hooks/useQueryParameters';
import useNavigationHelpers from 'hooks/useNavigationHelpers';

const useWarningTime = (): number => {
  const timeouts = useSelector(selectTimeouts);
  const { applicationWarningTime } = useQueryParameters();

  return applicationWarningTime || timeouts.appWarning;
};

const useTimeoutTime = (): number => {
  const timeouts = useSelector(selectTimeouts);
  const { applicationTimeoutTime } = useQueryParameters();

  return applicationTimeoutTime || timeouts.appTimeout;
};

const useMaxExtensions = (): number => {
  return 3;
};

const AppTimeoutModal: React.FC = props => {
  const [warned, extendSession] = useWarning(
    useWarningTime(),
    useMaxExtensions(),
  );

  const allowedQueryParameters = useSecureQueryParameters();
  const timeoutAfter = useTimeoutTime();
  const { push } = useNavigationHelpers();
  const onTimeout = useCallback(() => {
    push({
      pathname: '/app-expired',
      search: qs.stringify(allowedQueryParameters, { addQueryPrefix: true }),
    });
  }, [allowedQueryParameters, push]);
  useIdleTimer(onTimeout, timeoutAfter * 1000);

  return (
    <AppTimeoutModalView
      warned={warned}
      extendSession={extendSession}
      endSession={onTimeout}
    >
      {props.children}
    </AppTimeoutModalView>
  );
};

export default AppTimeoutModal;
